'use strict';
var parent = require('../../stable/iterator/find');
require('../../modules/esnext.iterator.constructor');
require('../../modules/esnext.iterator.find');

module.exports = parent;
